import { MutationKeys } from './service.js';
import WebRequest from './client/WebRequest.js';
export var StartTfaChallenge;
(function (StartTfaChallenge) {
    function api({ data }) {
        return WebRequest.POST('/tfa/start').body(data);
    }
    function mutation(client) {
        return {
            mutationFn: (params) => client.execute(api(params)),
            mutationKey: MutationKeys.StartTfaChallenge(),
        };
    }
    StartTfaChallenge.mutation = mutation;
})(StartTfaChallenge || (StartTfaChallenge = {}));
export var VerifyTfaChallenge;
(function (VerifyTfaChallenge) {
    function api({ data }) {
        return WebRequest.POST('/tfa/verify').body(data);
    }
    function mutation(client) {
        return {
            mutationFn: (params) => client.execute(api(params)),
            mutationKey: MutationKeys.VerifyTfaChallenge(),
        };
    }
    VerifyTfaChallenge.mutation = mutation;
})(VerifyTfaChallenge || (VerifyTfaChallenge = {}));
